import NavigateFunctionComponent from './NavigateFunction';

export default NavigateFunctionComponent;
